export default "__VITE_ASSET__Cdq34gcA__"